export default "__VITE_ASSET__DkKOEOKW__"